export type IdentitySystemRole = "mentor" | "mentee";

export const hasSystemRole = (
  systemRoles: string[] | undefined,
  role: IdentitySystemRole,
): boolean => !!systemRoles?.includes(role);

export const isMentorIdentity = (systemRoles: string[] | undefined): boolean =>
  hasSystemRole(systemRoles, "mentor");

export const isMenteeIdentity = (systemRoles: string[] | undefined): boolean =>
  hasSystemRole(systemRoles, "mentee");

export const getMentorshipActorType = (
  systemRoles: string[] | undefined,
): "mentor" | "mentee" | null => {
  if (hasSystemRole(systemRoles, "mentee")) return "mentee";
  if (hasSystemRole(systemRoles, "mentor")) return "mentor";
  return null;
};

export const ROLE_PRECEDENCE = [
  "superadmin",
  "supervisor",
  "admin",
  "lead_mentor",
  "mentor",
  "mentee",
] as const;

export type PrimaryRole = (typeof ROLE_PRECEDENCE)[number];

export const getPrimaryRole = (
  systemRoles: string[] | undefined,
): PrimaryRole | null =>
  ROLE_PRECEDENCE.find((r) => systemRoles?.includes(r)) ?? null;

export const hasNonMentorRole = (
  systemRoles: string[] | undefined,
): boolean => !!systemRoles?.some((role) => role !== "mentor");
